import { Injectable } from '@angular/core';
import { UserRoles } from '@auth/auth.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  public ruoloAttuale: BehaviorSubject<string> = new BehaviorSubject<string>(
    ''
  );
  private ruoloAttualeVal: string = '';
  private listaRuoliUtente: string[] = [];

  private ordinamentoRuoli: string[] = [
    UserRoles.REGIONE,
    UserRoles.CPI,
    UserRoles.ENTE,
    UserRoles.DOCENTE,
    UserRoles.CITTADINO,
    UserRoles.PRESIDENTE,
    UserRoles.TUTOR,
  ];

  constructor() {}

  getListaRuoliUtente(): string[] {
    return this.listaRuoliUtente;
  }

  getRuoloAttualeVal(): string {
    return this.ruoloAttualeVal;
  }

  setRuoloAttualeFromStorage(): void {
    this.ruoloAttuale.next(localStorage.getItem('ruoloAttuale') ?? '');
    this.ruoloAttualeVal = localStorage.getItem('ruoloAttuale') ?? '';
  }

  setRuoloAttuale(ruolo: string) {
    localStorage.setItem('ruoloAttuale', ruolo);
    this.ruoloAttuale.next(ruolo);
    this.ruoloAttualeVal = ruolo;
  }

  setListaRuoliUtente(lista: string[]) {
    this.listaRuoliUtente = lista;
  }

  isRuoloAttualeSettedOnStorage(): boolean {
    return !!localStorage.getItem('ruoloAttuale');
  }

  isRuoloOnStorageValid(): boolean {
    const ruolo = localStorage.getItem('ruoloAttuale');
    return !!(ruolo && this.listaRuoliUtente.includes(ruolo));
  }

  getRuoloPrincipaleUtente(): string {
    for (const ruolo of this.ordinamentoRuoli) {
      if (this.listaRuoliUtente.includes(ruolo)) {
        return ruolo;
      }
    }
    return '';
  }
}
